import jsxc from 'jsxc'
import ENV from 'ENV'

export default {
  token: null,
  getToken () {
    this.token = JSON.parse(sessionStorage.getItem('token'))
  },
  isUserAuthenticated () {
    return this.token !== null && this.token !== undefined
  },
  initChatComponent (user, password) {
    // console.log('initChatComponent')
    jsxc.init({
      xmpp: {
        url: ENV.server_xmpp
      },
      root: '/jsxc/'
    })
    jsxc.start(`${user}@${ENV.server_name_xmpp}`, password)

    // setTimeout(function () {
    //   var salaChat = 'welcome'
    //   var sesion = sessionStorage.getItem('datos_usuario_autenticado')

    //   jsxc.gui.dialog.open('Ingresando a área de chat...' + JSON.parse(sesion).nombre_completo) // Si aparece el cuadro de dialogo primero si se maximiza la ventana de chat

    //   jsxc.muc.join(`${salaChat}@conference.${ENV.server_name_xmpp}`, JSON.parse(sesion).nombre_completo, null, null, null, null)
    // }, 10000)
  },
  parseJwt (token) {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(jsonPayload)
  },
  loginChat () {
    this.getToken()
    if (this.isUserAuthenticated()) {
      const usuarioAutenticado = JSON.parse(sessionStorage.getItem('datos_usuario_autenticado'))
      const payload = this.parseJwt(this.token.access_token)

      const user = usuarioAutenticado.correo_electronico.replace('@', '$')
      const pass = btoa(payload.sub)
      this.initChatComponent(user, pass)
    }
  },
  logoutChat () {
    jsxc.xmpp.conn.disconnect()
    this.cerrarJSXC()
  },
  cerrarJSXC () {
    document.getElementById('jsxc_windowList').remove()
    document.getElementById('jsxc_windowListSB').remove()
    document.getElementById('jsxc_roster').remove()
    // document.getElementsByClassName('ui-helper-hidden-accessible').remove()
  }
}



// WEBPACK FOOTER //
// ./src/js/session.js